import type { SsoProvider, SsoStrategy } from '../types/sso';

export const SSO_PROVIDER_OF: Record<SsoStrategy, SsoProvider> = { oauth_google: 'google', oauth_microsoft: 'microsoft' };

/** Fallback text when Clerk refuses a Google or Microsoft sign-in without a message. */
export const ssoLoginFailedMessage = (provider: SsoProvider): string =>
  `${provider === 'google' ? 'Google' : 'Microsoft'} login failed.`;

/** Sign-in providers this deployment hides, from `VITE_DISABLED_SSO_PROVIDERS` (comma-separated, lowercase). */
export const DISABLED_SSO_PROVIDERS: ReadonlySet<string> = new Set(
  (import.meta.env.VITE_DISABLED_SSO_PROVIDERS || '')
    .split(',')
    .map((s: string) => s.trim().toLowerCase())
    .filter(Boolean),
);
